import { createFileRoute } from "@tanstack/react-router";
import { OutboundClientsPage } from "@/features/outbound/outbound-clients-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/weryfikacja-wysylek/klienci")({
	component: OutboundClientsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.weryfikacja-wysylek",
			location.pathname,
		);
	},
});
